module.exports = __webpack_public_path__ + "img/jacopo.4c8223f4.png";